<template>
  <div class="container">
    <div class="row p-1">
      <!-- <div class="col">
        <i
          class="bi bi-arrow-clockwise text-primary float-start"
          @click="fetchLivePlayer()"
        ></i>
      </div> -->
      <div class="col">
        <i
          class="bi bi-x-lg float-end text-danger"
          v-if="live_player_id"
          @click="clearLivePlayer()"
        ></i>
      </div>
    </div>
    <Transition>
      <div>
        <div class="row" v-if="live_player_data.team_id">
          <div class="col">
            <h5 class="text-danger">Sold!</h5>
          </div>
        </div>
        <div class="row mt-1" v-if="live_player_id">
          <div class="col w-50">
            <PlayerPic :player_id="live_player_id"></PlayerPic>
          </div>
          <div class="col w-50">
            <PlayerName :player_id="live_player_id"></PlayerName>
            <PlayerStats :player_id="live_player_id"></PlayerStats>
          </div>
        </div>
        <div class="mt-1" v-if="live_player_id && !sold_to">
          <!--SALE BUTTON IN THIS COMPOMENT-->
          <BidsListner :player_id="live_player_id"></BidsListner>
          <!--SALE BUTTON HERE-->
        </div>
        <div v-if="live_player_id">
          <PlayerControl
            :player_id="live_player_id"
            :bidding_open="bidding_open"
            :halt_bidding="halt_bidding"
            :sold_to="sold_to"
          ></PlayerControl>
        </div>
      </div>
    </Transition>
  </div>
</template>
<script setup>
import { onMounted, ref, watchEffect, computed } from "vue";
import PlayerName from "../livepools/PlayerName.vue";
import PlayerPic from "../liveplayer/PlayerPic.vue";
import PlayerControl from "../liveplayer/PlayerControl.vue";
import BidsListner from "./BidsListner.vue";
import PlayerStats from "./PlayerStats.vue";
import supabase from "@/supabase/config";
import { useStore } from "@/store/index";
const store = useStore();
const live_player_id = ref("");
const bidding_open = ref(false);
const halt_bidding = ref(false);
const live_player_data = ref({ team_id: null });
const fetchLivePlayer = async () => {
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  var temp = auctions[0];
  //console.log(temp);
  live_player_id.value = temp.live_player_id;
  bidding_open.value = temp.bidding_open;
  halt_bidding.value = temp.halt_bidding;
  setupListner();
};
watchEffect(() => {
  if (live_player_id.value) {
    isPlayerSold();
  } else {
    // console.log("no player live... ");
    live_player_data.value = { team_id: null };
  }
});
onMounted(() => {
  setupListner();
});
const isPlayerSold = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("id", live_player_id.value);
  live_player_data.value = players[0];
  setupListnerToPlayer();
};
const setupListnerToPlayer = () => {
  const channels = supabase
    .channel("player-sale-filter-channel")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "players",
        filter: `id=eq.${live_player_id.value}`,
      },
      (payload) => {
        isPlayerSold();
        //console.log("Change received!", payload);
      }
    )
    .subscribe();
};
const setupListner = () => {
  const channels = supabase
    .channel("auction-liveplayer-update-channel")
    .on(
      "postgres_changes",
      {
        event: "UPDATE",
        schema: "public",
        table: "auctions",
        filter: `id=eq.${store.live_auction}`,
      },
      (payload) => {
        //console.log("Change received!", payload.new.live_player_id);
        live_player_id.value = payload.new.live_player_id;
        bidding_open.value = payload.new.bidding_open;
        halt_bidding.value = payload.new.halt_bidding;
      }
    )
    .subscribe();
};
const clearLivePlayer = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ live_player_id: null })
    .eq("id", store.live_auction)
    .select();
  setBiddingOpenToFalse();
};
const setBiddingOpenToFalse = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ bidding_open: false })
    .eq("id", store.live_auction)
    .select();
};
const sold_to = computed(() => {
  var team_id = "";
  team_id = live_player_data.value.team_id;
  return team_id;
});
</script>
<style scoped>
/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
  transition: opacity 1s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
